<script>
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Utilizatori',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Telefon', value: 'username' },
                { text: 'E-mail', value: 'email' },
                { text: 'Roluri', sortable: false, value: 'rolesList'},
                { text: 'Activ', value: 'active' },
                { text: 'Data crearii', value: 'created_at' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                this.loading = true
                let { data, meta } = await this.$db.Employee
                    .orderBy(this.orderBy)
                    .include('roles')
                    .append('is_active')
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                    .get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            editItem (item) {
                this.$router.push({ name: 'employees-edit', params: { id: item.id } })
            },

            deleteItem (item) {
            },

            async deleteItemConfirm () {
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function() {
                this.$router.push({ name: 'employees-create' })
            },
            canDelete() {
                return false
            }
        },
    };
</script>
